import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { UnitOfMeasure, UnitOfMeasureCreate, UnitOfMeasureFilter } from '../data/unitOfMeasure';

export function createUnitOfMeasureService(client: AxiosInstance) {
  return createCrudService<UnitOfMeasure, UnitOfMeasureCreate, UnitOfMeasureFilter>(
    client,
    '/master-data/UnitOfMeasure',
    'id',
  );
}

export type UnitOfMeasureService = CrudService<UnitOfMeasure, UnitOfMeasureCreate, UnitOfMeasureFilter>;
